import { render, staticRenderFns } from "./puzzle.vue?vue&type=template&id=5b74fa42&v-once=true"
import script from "./puzzle.vue?vue&type=script&lang=js"
export * from "./puzzle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports